<div class="sticky p-12">
    <ng-content></ng-content>
</div>
